import React from "react";
import {
  Box,
  Button,
  Typography,
  IconButton,
  Paper,
  TextField,
} from "@material-ui/core";
import AddIcon from "@material-ui/icons/Add";
import DeleteIcon from "@material-ui/icons/Delete";

function TestCaseSection({ classes, setFormDetails, formDetails }) {
  
  // Logic to add a new test case object to the specific array (public or private)
  const addTestCase = (type) => {
    setFormDetails((prev) => ({
      ...prev,
      [type]: [
        ...(prev[type] || []),
        {
          input: "",
          expected_output: "",
        },
      ],
    }));
  };

  // Logic to remove a test case by index
  const removeTestCase = (type, index) => {
    setFormDetails((prev) => ({
      ...prev,
      [type]: prev[type].filter((_, i) => i !== index),
    }));
  };

  // Fixed HandleChange: Uses functional updates to ensure state integrity
  const handleChange = (type, index, field, value) => {
    setFormDetails((prev) => {
      const updatedList = [...(prev[type] || [])];
      updatedList[index] = {
        ...updatedList[index],
        [field]: value,
      };
      return {
        ...prev,
        [type]: updatedList,
      };
    });
  };

  const renderSection = (type, label) => (
    <div className={`${classes.dflex} ${classes.justifyspacebetween} ${classes.mt1}`}>
      {/* LEFT LABEL */}
      <Typography
        className={`${classes.w24} ${classes.mb1} ${classes.textcolorformhead} 
        ${classes.fontfamilyoutfit} ${classes.fontsize} 
        ${classes.fontstylenormal} ${classes.fw500} ${classes.lineheight2_25}`}
        variant="h6"
      >
        {label}
      </Typography>

      {/* RIGHT CONTENT */}
      <div className={`${classes.dflex} ${classes.flexdirectioncolumn} ${classes.w75}`}>
        {/* ADD BUTTON */}
        <div className={classes.mb1}>
          <Button
            className={`${classes.custombtnblue}`}
            startIcon={<AddIcon />}
            onClick={() => addTestCase(type)}
            variant="contained"
            color="primary"
          >
            Add Test Case
          </Button>
        </div>

        {/* TEST CASE LIST */}
        {formDetails[type]?.map((tc, index) => (
          <Paper
            key={index}
            elevation={2}
            style={{ padding: 20, marginBottom: 20, borderRadius: 8 }}
          >
            <div className={`${classes.dflex} ${classes.justifyspacebetween}`} style={{ alignItems: 'center', marginBottom: 10 }}>
              <Typography variant="subtitle1" style={{ fontWeight: 600 }}>
                Test Case #{index + 1}
              </Typography>

              <IconButton
                color="secondary"
                onClick={() => removeTestCase(type, index)}
                size="small"
              >
                <DeleteIcon />
              </IconButton>
            </div>

            <div style={{ display: "flex", justifyContent: "space-between", gap: "15px" }}>
              {/* INPUT FIELD */}
              <div style={{ width: "50%" }}>
                <Typography variant="caption" color="textSecondary" gutterBottom>
                  INPUT
                </Typography>
                <TextField
                  variant="outlined"
                  fullWidth
                  multiline
                  rows={4}
                  placeholder="Enter input here..."
                  value={tc.input}
                  onChange={(e) => handleChange(type, index, "input", e.target.value)}
                />
              </div>

              {/* EXPECTED OUTPUT FIELD */}
              <div style={{ width: "50%" }}>
                <Typography variant="caption" color="textSecondary" gutterBottom>
                  EXPECTED OUTPUT
                </Typography>
                <TextField
                  variant="outlined"
                  fullWidth
                  multiline
                  rows={4}
                  placeholder="Enter expected output..."
                  value={tc.expected_output}
                  onChange={(e) => handleChange(type, index, "expected_output", e.target.value)}
                />
              </div>
            </div>
          </Paper>
        ))}
      </div>
    </div>
  );

  return (
    <Box py={2}>
      {renderSection("public_input", "Public Test Cases")}
      <Box my={4} style={{ borderBottom: '1px solid #eee' }} />
      {renderSection("private_input", "Private Test Cases")}
    </Box>
  );
}

export default TestCaseSection;